import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box, Dialog, IconButton, Typography
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';

import CancelBtn from 'src/shared/buttons/CancelBtn';
import styles from './style';

interface PropTypes {
  open: boolean;
  onClose: () => void;
  nodeType: string | null;
  nodeId: string | null;
  label: string | null;
  configuration: Record<string, any>;
  isSaving?: boolean;
  // eslint-disable-next-line no-unused-vars
  onConfigurationSave: (nodeId: string, configuration: Record<string, any>) => void;
}

const DigitizeComponent = (props: PropTypes) => {
  const { t } = useTranslation();

  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      sx={styles.modal}
      onClose={onClose}
    >
      <Box sx={styles.container}>
        <Box sx={styles.modalHeader}>
          <Box sx={styles.titleContainer}>
            <Typography sx={styles.headerTitle}>
              {t('WORKFLOW_NODE_SETTINGS_DIGITIZE')}
            </Typography>
            <IconButton sx={styles.closeBtn} onClick={onClose}>
              <CloseIcon sx={styles.closeIcon} />
            </IconButton>
          </Box>
        </Box>
        <Box sx={styles.modalContent}>
          <Typography sx={styles.description}>
            {t('WORKFLOW_DIGITIZE_DESCRIPTION')}
          </Typography>
        </Box>
        <Box sx={styles.modalFooter}>
          <Box display="flex" justifyContent="flex-end" gap="16px">
            <CancelBtn
              title={t('WORKFLOW_BUTTON_CLOSE')}
              onClick={onClose}
            />
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default DigitizeComponent;
